//获取地址详情
export const SET_ADDRESS_ITEM = "SET_ADDRESS_ITEM";

//设置寄件地址
export const SET_SEND_ADDRESS = "SET_SEND_ADDRESS";

//检查是否可以修改地址
export const CHECK_EDIT_AVAILABLE = "CHECK_EDIT_AVAILABLE"


// WEBPACK FOOTER //
// ./src/store/address-manage/type.js